import { setGetStreamToken } from "../slices/getstream-slice";

export const mapDispatchToProps = (dispatch) => ({
  setGetStreamToken: (payload) => dispatch(setGetStreamToken(payload)),
});
